export default "__VITE_ASSET__bJc7xJbY__"